import { Toolbar, ToolbarButton, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { ExtendedArchive } from "../../library/CosmeWidgetAPIClient";

import {
    ZoomIn24Filled,
    ZoomIn24Regular,
    ZoomOut24Filled,
    ZoomOut24Regular,
    ArrowDownload24Filled,
    ArrowDownload24Regular,

    bundleIcon,
} from "@fluentui/react-icons";
import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import PageLoading from "../PageLoading";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


// bundleIcons 
const ZoomIn = bundleIcon(
    ZoomIn24Filled,
    ZoomIn24Regular,
);
const ZoomOut = bundleIcon(
    ZoomOut24Filled,
    ZoomOut24Regular,
);
const Download = bundleIcon(
    ArrowDownload24Filled,
    ArrowDownload24Regular,
);

// style define
const useStyles = makeStyles({
    viewerFrame: {
        width: "100%",
        height: "85vh",
        maxHeight: "85vh",
        ...shorthands.overflow("scrool"),
        boxShadow: tokens.shadow8,
    },
});
type PreviewPainProp =
    { archive: ExtendedArchive };

const PreviewPain = (prop: PreviewPainProp) => {
    const archive = prop.archive;
    const styles = useStyles();
    const [zoom, setZoom] = useState(1.3);

    if (archive !== undefined) {
        console.log(archive.viewerUrl);
        return (
            <>
                <Toolbar>
                    <ToolbarButton icon={<ZoomIn />}
                        onClick={() => {
                            setZoom(zoom + 0.1);
                        }}
                    />
                    <ToolbarButton icon={<ZoomOut />}

                        onClick={() => {
                            setZoom(zoom - 0.1);
                        }}
                    />
                    <ToolbarButton icon={<Download />}
                        onClick={() => {
                            window.open(archive.viewerUrl);
                        }}
                    />
                </Toolbar>
                <div
                    className={styles.viewerFrame}
                    style={{ overflow: "scroll" }}
                >

                    <Document
                        file={archive.viewerUrl}
                        loading={<PageLoading
                            message="ページプレビューを読み込んでいます"
                        />}

                        onError={(err) => console.log(err)}
                    >
                        <Page
                            onProgress={(progressData) => console.log(progressData)}
                            pageNumber={1}
                            scale={zoom}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                        >
                        </Page>
                    </Document >
                </div>
            </>
        )
    } else {
        return (
            <PageLoading
                message="ページプレビューを読み込んでいます"
            />
        )
    }

}

export default PreviewPain;